import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export var Access;
(function (Access) {
    Access["Denied"] = "denied";
    Access["Error"] = "error";
    Access["Granted"] = "granted";
    /** @deprecated No longer needed */
    Access["Mismatch"] = "mismatch";
    Access["Pending"] = "pending";
})(Access || (Access = {}));
export var ComponentName;
(function (ComponentName) {
    ComponentName["Checkout"] = "checkout";
    ComponentName["Configurator"] = "configurator";
    ComponentName["Fincalc"] = "fincalc";
    ComponentName["Insurance"] = "insurance";
    ComponentName["Myaccount"] = "myaccount";
    ComponentName["Se"] = "se";
})(ComponentName || (ComponentName = {}));
export var DealTypes;
(function (DealTypes) {
    DealTypes["Enquiries"] = "enquiries";
    DealTypes["Orders"] = "orders";
    DealTypes["Reservations"] = "reservations";
    DealTypes["SavedCars"] = "savedCars";
})(DealTypes || (DealTypes = {}));
export var DepositType;
(function (DepositType) {
    DepositType["Absolute"] = "absolute";
    DepositType["Percentage"] = "percentage";
})(DepositType || (DepositType = {}));
export var DisabledDeal;
(function (DisabledDeal) {
    DisabledDeal["DealExpired"] = "dealExpired";
    DisabledDeal["DealInfoOutOfDate"] = "dealInfoOutOfDate";
    DisabledDeal["DealNotAvailable"] = "dealNotAvailable";
    DisabledDeal["FinanceApplicationExists"] = "financeApplicationExists";
    DisabledDeal["ModifiedByDealer"] = "modifiedByDealer";
})(DisabledDeal || (DisabledDeal = {}));
export var FacetOptionStatus;
(function (FacetOptionStatus) {
    FacetOptionStatus["Disabled"] = "DISABLED";
    FacetOptionStatus["Enabled"] = "ENABLED";
    FacetOptionStatus["Selected"] = "SELECTED";
})(FacetOptionStatus || (FacetOptionStatus = {}));
export var FeatureType;
(function (FeatureType) {
    FeatureType["Multi"] = "multi";
    FeatureType["Mutex0"] = "mutex0";
    FeatureType["Mutex1"] = "mutex1";
})(FeatureType || (FeatureType = {}));
export var FinanceApplicationJourney;
(function (FinanceApplicationJourney) {
    FinanceApplicationJourney["Default"] = "DEFAULT";
    FinanceApplicationJourney["OnlineApplication"] = "ONLINE_APPLICATION";
    FinanceApplicationJourney["RequestQuote"] = "REQUEST_QUOTE";
})(FinanceApplicationJourney || (FinanceApplicationJourney = {}));
export var FinanceFormCustomerType;
(function (FinanceFormCustomerType) {
    FinanceFormCustomerType["Business"] = "business";
    FinanceFormCustomerType["Private"] = "private";
})(FinanceFormCustomerType || (FinanceFormCustomerType = {}));
export var FinanceFormType;
(function (FinanceFormType) {
    FinanceFormType["Cash"] = "cash";
    FinanceFormType["Finance"] = "finance";
})(FinanceFormType || (FinanceFormType = {}));
export var FinanceResultType;
(function (FinanceResultType) {
    FinanceResultType["Cash"] = "cash";
    FinanceResultType["Error"] = "error";
    FinanceResultType["Finance"] = "finance";
    FinanceResultType["Na"] = "na";
    FinanceResultType["NotApplicable"] = "not_applicable";
})(FinanceResultType || (FinanceResultType = {}));
export var JourneyType;
(function (JourneyType) {
    JourneyType["ContinueInDealership"] = "continue_in_dealership";
    JourneyType["OnlineOrder"] = "online_order";
    JourneyType["PreOrderNow"] = "pre_order_now";
    JourneyType["ReserveOnline"] = "reserve_online";
    JourneyType["SaveMyBuild"] = "save_my_build";
})(JourneyType || (JourneyType = {}));
export var LoanTermPeriodUnit;
(function (LoanTermPeriodUnit) {
    LoanTermPeriodUnit["Month"] = "month";
})(LoanTermPeriodUnit || (LoanTermPeriodUnit = {}));
export var MiscellaneousOptionTypes;
(function (MiscellaneousOptionTypes) {
    MiscellaneousOptionTypes["ComplexInput"] = "complexInput";
    MiscellaneousOptionTypes["DefaultInput"] = "defaultInput";
    MiscellaneousOptionTypes["JlrPolandInput"] = "jlrPolandInput";
    MiscellaneousOptionTypes["MercedesPhInput"] = "mercedesPhInput";
    MiscellaneousOptionTypes["SimpleInput"] = "simpleInput";
    MiscellaneousOptionTypes["SubaruAuInput"] = "subaruAuInput";
})(MiscellaneousOptionTypes || (MiscellaneousOptionTypes = {}));
export var MyAccountRedirectTarget;
(function (MyAccountRedirectTarget) {
    MyAccountRedirectTarget["Login"] = "login";
    MyAccountRedirectTarget["SetPassword"] = "setPassword";
})(MyAccountRedirectTarget || (MyAccountRedirectTarget = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["FullPayment"] = "full_payment";
    PaymentType["OrderCar"] = "order_car";
    PaymentType["ReservationFee"] = "reservation_fee";
})(PaymentType || (PaymentType = {}));
export var PriceTypes;
(function (PriceTypes) {
    PriceTypes["FinalPrice"] = "FinalPrice";
    PriceTypes["NetPrice"] = "NetPrice";
})(PriceTypes || (PriceTypes = {}));
export var QuoteError;
(function (QuoteError) {
    QuoteError["CarLoading"] = "carLoading";
    QuoteError["ConfigLoading"] = "configLoading";
    QuoteError["FinanceCalculation"] = "financeCalculation";
    QuoteError["FinanceNotSupported"] = "financeNotSupported";
    QuoteError["FinanceProductNotApplicable"] = "financeProductNotApplicable";
    QuoteError["InvalidFinanceCriteria"] = "invalidFinanceCriteria";
})(QuoteError || (QuoteError = {}));
export var Source;
(function (Source) {
    Source["Checkout"] = "checkout";
    Source["FinanceApplication"] = "financeApplication";
    Source["Insurance"] = "insurance";
})(Source || (Source = {}));
export var StockListingView;
(function (StockListingView) {
    StockListingView["Aggregated"] = "aggregated";
    StockListingView["Individual"] = "individual";
})(StockListingView || (StockListingView = {}));
export var StockType;
(function (StockType) {
    StockType["Dealer"] = "dealer";
    StockType["Distribution"] = "distribution";
})(StockType || (StockType = {}));
export var TermUnit;
(function (TermUnit) {
    TermUnit["Month"] = "month";
})(TermUnit || (TermUnit = {}));
export var TokenType;
(function (TokenType) {
    TokenType["Bearer"] = "BEARER";
})(TokenType || (TokenType = {}));
export const BaseImageFragmentDoc = gql `
    fragment BaseImage on Image {
  url
  type
}
    `;
export const MoneyFragmentDoc = gql `
    fragment Money on Money {
  amount
  currency
}
    `;
export const InteriorFragmentDoc = gql `
    fragment Interior on Interior {
  shortname
  categoryCode
  code
  attributes {
    oemcode
  }
  price {
    money {
      ...Money
    }
  }
}
    ${MoneyFragmentDoc}`;
export const ExteriorFragmentDoc = gql `
    fragment Exterior on Exterior {
  code
  categoryCode
  shortname
  attributes {
    oemcode
  }
  price {
    money {
      ...Money
    }
  }
}
    ${MoneyFragmentDoc}`;
export const VariantFragmentDoc = gql `
    fragment Variant on Variant {
  code
  attributes {
    name
    year
    modelName
    fullSpecsUrl
  }
}
    `;
export const ModelFragmentDoc = gql `
    fragment Model on Model {
  code
  attributes {
    oemcode
    shortname
    modelyear
    brand
    fullSpecsUrl
    longdescription
    label
  }
}
    `;
export const EngineFragmentDoc = gql `
    fragment Engine on Engine {
  code
  attributes {
    shortname
    shortdescription
    longdescription
    fuelType
    fuelLabel
    powertrain
    capacity
    transmissionLabel
    maximumpower
    maximumtorque
    enginepower
    transmissionType
    acceleration
    fueleconomy_wltpconsumption_teh
  }
}
    `;
export const SpecPackFragmentDoc = gql `
    fragment SpecPack on SpecPack {
  code
  attributes {
    shortname
    nviccode
  }
}
    `;
export const PriceWithTaxFragmentDoc = gql `
    fragment PriceWithTax on Price {
  money {
    ...Money
  }
  taxes {
    aggregated
    type
    money {
      ...Money
    }
    aggregated
    label
  }
  type
}
    ${MoneyFragmentDoc}`;
export const BadgeFragmentDoc = gql `
    fragment Badge on Badge {
  image
  label
}
    `;
export const DiscountFragmentDoc = gql `
    fragment Discount on Discount {
  code
  badge {
    ...Badge
  }
  label
  value {
    ...Money
  }
  disclaimer
}
    ${BadgeFragmentDoc}
${MoneyFragmentDoc}`;
export const OffersFragmentDoc = gql `
    fragment Offers on Offers {
  badge {
    ...Badge
  }
  discounts {
    ...Discount
  }
}
    ${BadgeFragmentDoc}
${DiscountFragmentDoc}`;
export const DealCarPriceFragmentDoc = gql `
    fragment DealCarPrice on DealCarPrice {
  originalPrice {
    ...PriceWithTax
  }
  totalDiscount {
    ...Money
  }
  finalPrice {
    ...PriceWithTax
  }
  offers {
    ...Offers
  }
}
    ${PriceWithTaxFragmentDoc}
${MoneyFragmentDoc}
${OffersFragmentDoc}`;
export const PriceFragmentDoc = gql `
    fragment Price on Price {
  money {
    ...Money
  }
  type
}
    ${MoneyFragmentDoc}`;
export const DealFeatureFragmentDoc = gql `
    fragment DealFeature on DealFeature {
  id
  shortname
  code
  categoryCode
  prices {
    ...Price
  }
  attributes {
    childrenDetails {
      id
      shortname
      categoryCode
      code
    }
  }
}
    ${PriceFragmentDoc}`;
export const PaymentInfoFragmentDoc = gql `
    fragment PaymentInfo on PaymentInfo {
  errorCode
  errorMessage
  actionCode
  actionDescription
  transactionId
  transactionTime
  card
  brand
}
    `;
export const ExpressionOfInterestFragmentDoc = gql `
    fragment ExpressionOfInterest on ExpressionOfInterest {
  code
  enabled
  attributes {
    picture
    label
    description
  }
}
    `;
export const DealerFragmentDoc = gql `
    fragment Dealer on Dealer {
  externalId
  attributes {
    publicToken
  }
  label
  address {
    name
    address
    city
    phone
  }
  postCode
}
    `;
export const FinanceValueFragmentDoc = gql `
    fragment FinanceValue on FinanceValue {
  amount
  currency
}
    `;
export const DealFinanceFragmentDoc = gql `
    fragment DealFinance on DealFinance {
  type
  formInput {
    paymentType
    financeProductId
    term
    deposit
    interestRate
    mileage
    homeOwner
  }
  simulation {
    amountPayable {
      ...Money
    }
    totalAmountPayable {
      ...Money
    }
    comparisonRate
    interestRate
    loanTermPeriod {
      unit
      value
    }
    paymentValue {
      ...Money
    }
    frequency
    deposit {
      ...Money
    }
    attributes {
      upfrontFees {
        ...FinanceValue
      }
      residualAmount {
        ...FinanceValue
      }
      depositAmountPercentage
      calculatorNetPrice
      balloonAmountPercentage
      residualAmountPercentage
      cae
    }
    financePackageId
    financeProductId
    financeProductName
    oneForOne
    roadCosts
  }
  breakdown {
    schema
  }
}
    ${MoneyFragmentDoc}
${FinanceValueFragmentDoc}`;
export const CustomerAttributesFragmentDoc = gql `
    fragment CustomerAttributes on CustomerAttributes {
  salutation
  postCode
  street
  city
  state
  country
  areaCode
  areaCodeKey
  preferredContactMethod
  identificationNumber
}
    `;
export const CustomerDetailsFragmentDoc = gql `
    fragment CustomerDetails on Customer {
  salutation
  firstName
  lastName
  phone
  email
  identificationNumber
  marketingInformation
  companyName
  customerType
  attributes {
    ...CustomerAttributes
  }
}
    ${CustomerAttributesFragmentDoc}`;
export const AppointmentDetailsFragmentDoc = gql `
    fragment AppointmentDetails on Appointment {
  preferredDate
  preferredTime
  attributes {
    comments
    salesConsultant
  }
}
    `;
export const PaymentFeeFragmentDoc = gql `
    fragment PaymentFee on PaymentFee {
  reserveFee {
    ...Money
  }
  orderFee {
    ...Money
  }
  fullPaymentFee {
    ...Money
  }
  paymentType
  refundableState
  inStorePaymentFee {
    ...Money
  }
  inStoreDescription
}
    ${MoneyFragmentDoc}`;
export const DealDataFragmentDoc = gql `
    fragment DealData on Deal {
  uuid
  disabled
  disabledReasons
  car {
    code
    displayName
    images {
      ...BaseImage
    }
    stock {
      vin
      dms
      stockType
      attributes
    }
    aggregatedOptions
    configurationSourceUrl
    nameplate {
      code
      attributes {
        brand
        shortname
        modelyear
        oemcode
      }
    }
    interior {
      ...Interior
    }
    exterior {
      ...Exterior
    }
    variant {
      ...Variant
    }
    model {
      ...Model
    }
    engine {
      ...Engine
    }
    specPack {
      ...SpecPack
    }
    bodyStyle {
      attributes {
        bodyStyleType
        longdescription
        oemcode
      }
    }
    prices {
      carPrice {
        ...DealCarPrice
      }
      totalPrice {
        ...PriceWithTax
      }
      totalConfiguration {
        ...Price
      }
      totalFeatures {
        ...Price
      }
      discounts {
        ...Discount
      }
      totalOfferFeatures {
        ...Price
      }
      totalNonFinanceableFeatures {
        ...Price
      }
    }
    standardFeatures {
      ...DealFeature
    }
    selectedFeatures {
      ...DealFeature
    }
    disclaimers {
      value
      purpose
      needsToBeTranslated
    }
    attributes {
      coeCategoryAmount {
        amount
        currency
      }
      freebies {
        code
        label
      }
      priceLabel
    }
  }
  paymentInfo {
    ...PaymentInfo
  }
  expressionsOfInterest {
    ...ExpressionOfInterest
  }
  insurance {
    applicationStatus
    applicationDate
    applicationAmended
    policy {
      money {
        ...Money
      }
    }
  }
  dealer {
    ...Dealer
  }
  finance {
    ...DealFinance
  }
  financeApplication {
    result
    status
    submissionId
    callbackRequested
    financeApplicationJourney
  }
  customer {
    ...CustomerDetails
  }
  appointment {
    ...AppointmentDetails
  }
  location {
    province
    district
    street
  }
  attributes {
    market
    modelyear
    co2
    range
    paymentFee {
      ...PaymentFee
    }
    tradeIn
    tradeInMake
    tradeInModel
    tradeInYear
    tradeInMileage
    tradeInRegistrationNumber
    tradeInComment
    isDistributionStock
    showErrorModal
    governmentEvRebate
    totalPurchaseAmount
    tradeInColour
    tradeInVariant
    vehicleDetailsPageUrl
    salesEnablement {
      additionalNotes
      tradeIn {
        tradeInAmount
        amountPayable
      }
    }
  }
  status
  journeyType
  currency
  region
  country
  brand
  language
  createdAt
  updatedAt
}
    ${BaseImageFragmentDoc}
${InteriorFragmentDoc}
${ExteriorFragmentDoc}
${VariantFragmentDoc}
${ModelFragmentDoc}
${EngineFragmentDoc}
${SpecPackFragmentDoc}
${DealCarPriceFragmentDoc}
${PriceWithTaxFragmentDoc}
${PriceFragmentDoc}
${DiscountFragmentDoc}
${DealFeatureFragmentDoc}
${PaymentInfoFragmentDoc}
${ExpressionOfInterestFragmentDoc}
${MoneyFragmentDoc}
${DealerFragmentDoc}
${DealFinanceFragmentDoc}
${CustomerDetailsFragmentDoc}
${AppointmentDetailsFragmentDoc}
${PaymentFeeFragmentDoc}`;
export const MountedFeatureFragmentDoc = gql `
    fragment MountedFeature on MountedFeature {
  code
  shortname
  image {
    url
  }
}
    `;
export const MountedFeaturesFragmentDoc = gql `
    fragment MountedFeatures on MountedFeatures {
  exterior {
    ...MountedFeature
  }
  interior {
    ...MountedFeature
  }
}
    ${MountedFeatureFragmentDoc}`;
export const CarPricesFragmentDoc = gql `
    fragment CarPrices on CarPrice {
  originalPrice {
    ...PriceWithTax
  }
  totalDiscount {
    ...Money
  }
  finalPrice {
    ...PriceWithTax
  }
  offers {
    ...Offers
  }
}
    ${PriceWithTaxFragmentDoc}
${MoneyFragmentDoc}
${OffersFragmentDoc}`;
export const QuotePricesFragmentDoc = gql `
    fragment QuotePrices on Prices {
  carPrice {
    ...CarPrices
  }
  totalPrice {
    ...PriceWithTax
  }
  totalConfiguration {
    ...Price
  }
  totalFeatures {
    ...Price
  }
  discounts {
    ...Discount
  }
  totalOfferFeatures {
    ...Price
  }
}
    ${CarPricesFragmentDoc}
${PriceWithTaxFragmentDoc}
${PriceFragmentDoc}
${DiscountFragmentDoc}`;
export const QuoteFinanceFragmentDoc = gql `
    fragment QuoteFinance on FinanceQuote {
  criteria {
    financeProduct {
      displayLabel
      id
    }
    paymentFrequency {
      displayLabel
      id
    }
    term {
      value
      unit
    }
    deposits {
      value {
        ...Money
      }
      percentageValue
    }
    mileage {
      value
    }
    interestRate {
      value
    }
    homeOwner {
      value
    }
    residualValue {
      value
    }
  }
  simulation {
    value {
      currency
      amount
    }
    totalAmountPayable {
      currency
      amount
    }
    amountFinanced {
      currency
      amount
    }
    interestRate {
      value
    }
    attributes {
      comparisonRate
      oneForOne
      balloonAmountPercentage
      depositAmountPercentage
      residualAmountPercentage
      cae
      upfrontFees
      residualAmount
      calculatorNetPrice
    }
    disclaimers {
      purpose
      value
    }
  }
}
    ${MoneyFragmentDoc}`;
export const DisclaimerFragmentDoc = gql `
    fragment Disclaimer on Disclaimer {
  value
  purpose
  needsToBeTranslated
}
    `;
export const CommonQuoteMinimalFragmentDoc = gql `
    fragment CommonQuoteMinimal on QuoteMinimal {
  prices {
    ...QuotePrices
  }
  offers {
    badge {
      image
      label
    }
  }
  finance {
    type
    quote {
      ...QuoteFinance
    }
    disclaimers {
      ...Disclaimer
    }
    editText
  }
  disclaimers {
    ...Disclaimer
  }
}
    ${QuotePricesFragmentDoc}
${QuoteFinanceFragmentDoc}
${DisclaimerFragmentDoc}`;
export const CheckoutBodyStyleFragmentDoc = gql `
    fragment CheckoutBodyStyle on BodyStyle {
  code
  attributes {
    shortname
    longdescription
    bodyStyleType @include(if: $dataLayer)
    oemcode @include(if: $dataLayer)
  }
}
    `;
export const CarPriceWithTaxFragmentDoc = gql `
    fragment CarPriceWithTax on CarPrice {
  originalPrice {
    ...PriceWithTax
  }
  totalDiscount {
    ...Money
  }
  finalPrice {
    ...PriceWithTax
  }
  offers {
    ...Offers
  }
}
    ${PriceWithTaxFragmentDoc}
${MoneyFragmentDoc}
${OffersFragmentDoc}`;
export const CriteriaFragmentDoc = gql `
    fragment Criteria on FinanceCriteria {
  financeProduct {
    id
    displayLabel
  }
  paymentFrequency {
    id
    displayLabel
  }
  term {
    value
  }
  deposits {
    value {
      amount
      currency
    }
  }
  mileage {
    value
  }
  ageRange {
    value
  }
  homeOwner {
    value
  }
  residualValue {
    value
  }
}
    `;
export const CustomerFragmentDoc = gql `
    fragment Customer on Customer {
  firstName
  lastName
  phone
  email
  attributes {
    ...CustomerAttributes
  }
}
    ${CustomerAttributesFragmentDoc}`;
export const QuoteTrimLevelsFragmentDoc = gql `
    fragment QuoteTrimLevels on TrimLevels {
  nameplate {
    code
    attributes {
      brand @include(if: $dataLayer)
      shortname
    }
  }
  model {
    attributes {
      modelyear @include(if: $dataLayer)
      longdescription @include(if: $dataLayer)
      shortname
    }
    code
  }
  engine {
    attributes {
      shortname
      longdescription @include(if: $dataLayer)
      fuelType @include(if: $dataLayer)
      fuelLabel @include(if: $dataLayer)
      powertrain @include(if: $dataLayer)
      capacity @include(if: $dataLayer)
      maximumpower @include(if: $dataLayer)
      enginepower @include(if: $dataLayer)
      maximumtorque @include(if: $dataLayer)
      transmissionLabel
      transmissionType @include(if: $dataLayer)
    }
  }
  bodyStyle {
    attributes {
      bodyStyleType @include(if: $dataLayer)
      longdescription @include(if: $dataLayer)
      oemcode @include(if: $dataLayer)
      shortname
    }
  }
  specificationPack {
    attributes {
      nviccode @include(if: $dataLayer)
      shortname
    }
  }
}
    `;
export const QuoteFeatureFragmentDoc = gql `
    fragment QuoteFeature on QuoteCarFeature {
  code
  label
  shortName
  attributes {
    categoryCode
    oemcode
    childrenDetails {
      id
      shortname
      categoryCode
      code
    }
  }
  prices {
    money {
      ...Money
    }
  }
  id
}
    ${MoneyFragmentDoc}`;
export const QuoteExtraFeatureFragmentDoc = gql `
    fragment QuoteExtraFeature on QuoteCarExtraFeature {
  code
  shortName
  attributes {
    categoryCode
  }
  prices {
    money {
      ...Money
    }
  }
  id
}
    ${MoneyFragmentDoc}`;
export const QuoteCarFragmentDoc = gql `
    fragment QuoteCar on QuoteCar {
  code
  displayName
  images {
    ...BaseImage
  }
  attributes {
    startConfigurationSourceUrl
    deliveryTimeFrame {
      deliveryTimeFrameLabel
    }
    freebies {
      code
      label
    }
    priceLabel
  }
  stock {
    vin
    dms
    stockType
    attributes
  }
  aggregatedOptions
  configurationSourceUrl
  trimLevels {
    ...QuoteTrimLevels
  }
  isForReservation
  features {
    selectedFeatures {
      ...QuoteFeature
    }
    selectedExtraFeatures {
      ...QuoteExtraFeature
    }
    interior {
      ...QuoteFeature
    }
    exterior {
      ...QuoteFeature
    }
    roof {
      ...QuoteFeature
    }
    standardFeatures {
      code
      shortName
      attributes {
        categoryCode
      }
      id
    }
  }
}
    ${BaseImageFragmentDoc}
${QuoteTrimLevelsFragmentDoc}
${QuoteFeatureFragmentDoc}
${QuoteExtraFeatureFragmentDoc}`;
export const QuoteFragmentDoc = gql `
    fragment Quote on Quote {
  id
  prices {
    ...QuotePrices
  }
  disclaimers {
    ...Disclaimer
  }
  offers {
    badge {
      image
      label
    }
  }
  finance {
    simulation {
      roadCosts
    }
    ...QuoteFinance
  }
  car {
    ...QuoteCar
  }
}
    ${QuotePricesFragmentDoc}
${DisclaimerFragmentDoc}
${QuoteFinanceFragmentDoc}
${QuoteCarFragmentDoc}`;
export const DealWithQuoteFragmentDoc = gql `
    fragment DealWithQuote on DealWithQuote {
  uuid
  disabledReasons
  paymentInfo @include(if: $isPayment) {
    ...PaymentInfo
  }
  expressionsOfInterest {
    ...ExpressionOfInterest
  }
  dealer {
    ...Dealer
  }
  customer {
    ...CustomerDetails
  }
  appointment {
    preferredDate
    preferredTime
    attributes {
      comments
      salesConsultant
    }
  }
  quote {
    ...Quote
  }
  status
  journeyType
  attributes {
    co2
    range
    paymentFee {
      ...PaymentFee
    }
    tradeIn
    tradeInMake
    tradeInModel
    tradeInYear
    tradeInMileage
    tradeInRegistrationNumber
    tradeInComment
    isDistributionStock
    showErrorModal
    tradeInColour
    tradeInVariant
    governmentEvRebate
    totalPurchaseAmount
    vehicleDetailsPageUrl
    salesEnablement {
      additionalNotes
      tradeIn {
        tradeInAmount
        amountPayable
      }
    }
  }
}
    ${PaymentInfoFragmentDoc}
${ExpressionOfInterestFragmentDoc}
${DealerFragmentDoc}
${CustomerDetailsFragmentDoc}
${QuoteFragmentDoc}
${PaymentFeeFragmentDoc}`;
export const FinanceFormInputFragmentDoc = gql `
    fragment FinanceFormInput on FinanceFormInputData {
  ageRange
  paymentType
  financeProductId
  financePackageId
  term
  deposit
  interestRate
  partExchangeId
  homeOwner
  mileage
  residualValue
}
    `;
export const StockAttributeFragmentDoc = gql `
    fragment StockAttribute on StockAttribute {
  code
  shortname
}
    `;
export const ListingAttributesFragmentDoc = gql `
    fragment ListingAttributes on StockAttributes {
  vin {
    ...StockAttribute
  }
  exteriorLabel
  interiorLabel
  stockDate {
    ...StockAttribute
  }
  make {
    ...StockAttribute
  }
  modelNumber {
    ...StockAttribute
  }
  engineCode {
    ...StockAttribute
  }
  modelCode {
    ...StockAttribute
  }
  engineNumber {
    ...StockAttribute
  }
  licenseNumber {
    ...StockAttribute
  }
  subModelId {
    ...StockAttribute
  }
  locationCode {
    ...StockAttribute
  }
  status {
    ...StockAttribute
  }
  inventorySource {
    ...StockAttribute
  }
}
    ${StockAttributeFragmentDoc}`;
export const ListingFeaturesFragmentDoc = gql `
    fragment ListingFeatures on Feature {
  shortname
  code
}
    `;
export const CarPriceFragmentDoc = gql `
    fragment CarPrice on CarPrice {
  originalPrice {
    ...Price
  }
  totalDiscount {
    ...Money
  }
  finalPrice {
    ...Price
  }
  offers {
    ...Offers
  }
}
    ${PriceFragmentDoc}
${MoneyFragmentDoc}
${OffersFragmentDoc}`;
export const PricesFragmentDoc = gql `
    fragment Prices on Prices {
  carPrice {
    ...CarPrice
  }
  totalFeatures {
    ...Price
  }
  totalConfiguration {
    ...Price
  }
  totalPrice {
    ...Price
  }
}
    ${CarPriceFragmentDoc}
${PriceFragmentDoc}`;
export const FinanceFragmentDoc = gql `
    fragment Finance on FinanceResult {
  type
  simulation {
    paymentValue {
      currency
      amount
    }
    interestRate
    comparisonRate
    frequency
    loanTermPeriod {
      value
      unit
    }
    deposits {
      value
      type
    }
  }
}
    `;
export const SimilarStockCarsFragmentDoc = gql `
    fragment SimilarStockCars on PimStockCar {
  carId
  vin
  selectedFeatures {
    selected
    added
    removed
    merged {
      merged
      into
    }
    requiresOneOf
  }
  images {
    ...BaseImage
  }
  carPrice {
    ...CarPrice
  }
  finance(financeFormInput: $financeFormInput) {
    ...Finance
  }
  carMatchLabel
  keyFeatures {
    id
    shortname
    shortDescription
    longDescription
    code
    categoryCode
  }
}
    ${BaseImageFragmentDoc}
${CarPriceFragmentDoc}
${FinanceFragmentDoc}`;
export const SimulationFragmentDoc = gql `
    fragment Simulation on Simulation {
  value {
    amount
    currency
  }
  totalAmountPayable {
    amount
    currency
  }
  amountFinanced {
    amount
    currency
  }
  interestRate {
    value
  }
}
    `;
export const TaxesFragmentDoc = gql `
    fragment Taxes on Price {
  taxes {
    type
    label
    money {
      ...Money
    }
  }
}
    ${MoneyFragmentDoc}`;
export const GetTranslationsDocument = gql `
    query GetTranslations {
  translations {
    code
    value
  }
}
    `;
/**
 * __useGetTranslationsQuery__
 *
 * To run a query within a React component, call `useGetTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTranslationsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetTranslationsDocument, options);
}
export function useGetTranslationsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetTranslationsDocument, options);
}
export const GetTranslationsByFamilyDocument = gql `
    query getTranslationsByFamily($family: String!) {
  translationsByFamily(family: $family) {
    code
    value
    __typename
  }
}
    `;
/**
 * __useGetTranslationsByFamilyQuery__
 *
 * To run a query within a React component, call `useGetTranslationsByFamilyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationsByFamilyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationsByFamilyQuery({
 *   variables: {
 *      family: // value for 'family'
 *   },
 * });
 */
export function useGetTranslationsByFamilyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetTranslationsByFamilyDocument, options);
}
export function useGetTranslationsByFamilyLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetTranslationsByFamilyDocument, options);
}
//# sourceMappingURL=graphql.autogenerated.js.map